import { render, staticRenderFns } from "./MesasCaixa.vue?vue&type=template&id=571bc21d&scoped=true"
import script from "./MesasCaixa.vue?vue&type=script&lang=js"
export * from "./MesasCaixa.vue?vue&type=script&lang=js"
import style0 from "./MesasCaixa.vue?vue&type=style&index=0&id=571bc21d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bc21d",
  null
  
)

export default component.exports